/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Media from 'react-media';
import { Grid, makeStyles } from '@material-ui/core';
import {
    array,
    func,
    bool,
} from 'prop-types';

import SimpleProduct from '../../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/GraphqlSimpleProduct';
import noop from '../../../../../helpers/noop';

const useStyles = makeStyles(() => ({
    productRow: {
        boxSizing: 'border-box',
        marginRight: '-10px',
        marginLeft: '-10px',
        width: 'auto',
    },
    simpleProduct4row: {
        flex: '0 0 25%',
        marginBottom: '30px',
        maxWidth: '25%',
        position: 'relative',
        width: '100%',
        paddingRight: '10px',
        paddingLeft: '10px',
    },
    simpleProduct3row: {
        margin: '0 5px 10px',
        maxWidth: 'calc(33% - 10px)',
        position: 'relative',
        width: '100%',
        paddingRight: '10px',
        paddingLeft: '10px',
    },
}));

const ProductGrid = ({
    products, trackClickThrough, PLARecommendations,
}) => {
    const classes = useStyles();

    return (
        <Media query="(max-width: 600px)">
            {(matches) => (
                <Grid container className={classes.productRow}>
                    {products.length !== 0
                        ? products.map((product) => {
                            const {
                                name, image, seo: { url }, skuPriceRange, availability, partNumber, brandId,
                            } = product;

                            return (
                                <Grid item key={product.name} className={matches ? classes.simpleProduct3row : classes.simpleProduct4row}>
                                    <SimpleProduct
                                        name={name}
                                        image={image}
                                        url={url}
                                        skuPriceRange={skuPriceRange}
                                        availability={availability}
                                        partNumber={partNumber}
                                        showSimpleProductRedesignAbTest={false}
                                        productBrand={brandId}
                                        productClickCallback={() => trackClickThrough(partNumber)}
                                        PLARecommendations={PLARecommendations}
                                    />
                                </Grid>
                            );
                        })
                        : null}
                </Grid>
            )}
        </Media>
    );
};

ProductGrid.propTypes = {
    products: array,
    trackClickThrough: func,
    PLARecommendations: bool,
};

ProductGrid.defaultProps = {
    products: [],
    trackClickThrough: noop,
    PLARecommendations: false,
};

export default ProductGrid;
